export const API_BASE_URL = 'https://hercupoverflows.in';
export const API_LIKE_ENDPOINT = `${API_BASE_URL}/add_like.php`;

export const API_ENDPOINTS = {
  LIST_BLOGS: `${API_BASE_URL}/blog_actions.php?action=list`,
  LIST_BLOGS_WITH_LIMIT: `${API_BASE_URL}/blog_actions.php?action=list_with_limit`,
  ADD_OR_EDIT_BLOG: `${API_BASE_URL}/blog_actions.php`,
  DELETE_BLOG: `${API_BASE_URL}/blog_actions.php`,
  GET_SINGLE_BLOG: `${API_BASE_URL}/blog_actions.php?action=get_single`,



  LIST_COMMENTS: `${API_BASE_URL}/comments.php?action=list`,
  ADD_COMMENT: `${API_BASE_URL}/comments.php?action=add`,
  ADD_REPLY: `${API_BASE_URL}/comments.php?action=reply`,
  DELETE_COMMENT: `${API_BASE_URL}/comments.php?action=delete`,





  LIST_POSTS: `${API_BASE_URL}/product_actions.php?action=list_posts`,
  ADD_OR_EDIT_POST: `${API_BASE_URL}/product_actions.php?action=add_or_edit_post`,
  DELETE_POST: `${API_BASE_URL}/product_actions.php?action=delete_post`,
};


export function formatBlogContent(content, maxLength) {
  if (!content) return '';
  let cleaned = content
    .replace(/\\r\\n/g, '')
    .replace(/\\'/g, "'")
    .replace(/\\"/g, '"');
  if (maxLength && cleaned.length > maxLength) {
    cleaned = cleaned.substring(0, maxLength) + '...';
  }
  return cleaned;
}
